import {ReactPlugin} from "@microsoft/applicationinsights-react-js";
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {createBrowserHistory} from "history";

let appInsightsInstance: ApplicationInsights | null = null;
let reactPlugin: ReactPlugin | null = null;

export function initializeAppInsights(connectionString: string): ApplicationInsights {
    if (appInsightsInstance) {
        return appInsightsInstance;
    }

    reactPlugin = new ReactPlugin();
    const browserHistory = createBrowserHistory();

    appInsightsInstance = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: {history: browserHistory}
            },
            enableAutoRouteTracking: true,
            disableExceptionTracking: false,
            autoTrackPageVisitTime: true,
            // Disable CORS correlation to prevent adding request-id/traceparent headers to external APIs
            // These headers cause CORS errors with third-party APIs like Avatar SDK
            enableCorsCorrelation: false,
            enableRequestHeaderTracking: false,
            enableResponseHeaderTracking: false,
            disableCookiesUsage: true,
            enableUnhandledPromiseRejectionTracking: true,
        }
    });

    appInsightsInstance.loadAppInsights();
    setupGlobalErrorHandlers();

    return appInsightsInstance;
}

export function getAppInsights(): ApplicationInsights | null {
    return appInsightsInstance;
}

function setupGlobalErrorHandlers(): void {
    if (typeof window === 'undefined') return;

    window.addEventListener('error', (event: ErrorEvent) => {
        if (appInsightsInstance) {
            appInsightsInstance.trackException({
                exception: event.error || new Error(event.message),
                severityLevel: 3,
                properties: {
                    filename: event.filename,
                    lineno: event.lineno,
                    colno: event.colno,
                    type: 'window.error'
                }
            });
        }
    });

    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        if (appInsightsInstance) {
            const error = event.reason instanceof Error
                ? event.reason
                : new Error(String(event.reason));

            appInsightsInstance.trackException({
                exception: error,
                severityLevel: 3,
                properties: {
                    type: 'unhandledrejection',
                    reason: String(event.reason)
                }
            });
        }
    });
}
